import { appStore } from '../../../app/AppStore';
import { siteUrlsSelector } from '../../../app/selectors/SiteUrlsSelectors';
import { Messages } from '../../../codegen/Localize';
import { CommonErrorCode } from '../../helpers/ErrorCodes';
import { L10n } from '../../L10n/L10n';
import { IErrorItem } from '../../models/MultipleItemResult';
import { ICustomViewInfo } from '../../ServerApi/CustomViews/ICustomViewInfo';
import { IErrorDetail } from '../ContentActionNotification';

function customViewUrl(info: ICustomViewInfo): string {
  const siteUrls = siteUrlsSelector(appStore.getState());
  return siteUrls.redirectToCustomViewUrl(info.viewId, info.owner.username, info.urlId);
}

function errorMessageFor(errorCode: number) {
  switch (errorCode) {
    case CommonErrorCode.CustomViewNotFound:
      return Messages.errorCustomViewNotFound({ ACTIONED: L10n.elideIfLong('deleted') });
    case CommonErrorCode.SiteUserNotFound:
      return Messages.errorUserNotFoundOnSite();
    default:
      return Messages.errorUnknown();
  }
}

function errorDetailsFor(errorItem: IErrorItem<ICustomViewInfo>): IErrorDetail {
  return {
    itemName: errorItem.item.name,
    itemUrl: customViewUrl(errorItem.item),
    errorMessage: errorMessageFor(errorItem.error.code)
  };
}

export const CustomViewErrors = {
  errorDetailsFor,
  errorMessageFor
};
